import { render, staticRenderFns } from "./v-footer.vue?vue&type=template&id=61a4a860&scoped=true"
import script from "./v-footer.vue?vue&type=script&lang=js"
export * from "./v-footer.vue?vue&type=script&lang=js"
import style0 from "./v-footer.vue?vue&type=style&index=0&id=61a4a860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a4a860",
  null
  
)

export default component.exports